// extracted by mini-css-extract-plugin
export default {"capPreloader":"src-components-CapPreloader--capPreloader","capPreloader__item":"src-components-CapPreloader--capPreloader__item"};